import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { NgmatModule } from "src/app/shared-module/ngmat/ngmat.module";
import { ReportRoutingModule } from "./report-routing.module";
import { AngularFontAwesomeModule } from "angular-font-awesome";
import { CustomModule } from 'src/app/shared-module/custom/custom.module';
import { FileUploadModule } from "ng2-file-upload";
import { DocViewerModule } from 'src/app/shared-module/doc-viewer/doc-viewer.module';
import { EBEnrolleeDashboardComponent } from './component/eb-enrollee-dashboard/eb-enrollee-dashboard.component';
import { EbClaimHistoryComponent } from './component/eb-claim-history/eb-claim-history.component';;
import { EBDashboardMemberAndBenefitComponent } from './component/eb-dashboard-member-and-benefit/eb-dashboard-member-and-benefit.component';
import { DialogEbClaimDetailsComponent } from './component/eb-claim-history/dialog-eb-claim-details/dialog-eb-claim-details.component';
import { EbClaimStatusDetailsComponent } from './component/eb-claim-history/eb-claim-status-details/eb-claim-status-details.component'

@NgModule({
  declarations: [
    EBEnrolleeDashboardComponent,
    EbClaimHistoryComponent,
    EBDashboardMemberAndBenefitComponent,
    DialogEbClaimDetailsComponent,
    EbClaimStatusDetailsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgmatModule,
    ReportRoutingModule,
    AngularFontAwesomeModule,
    FileUploadModule,
    CustomModule,
    DocViewerModule
  ],
  entryComponents: [DialogEbClaimDetailsComponent],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ReportingModule { }
